import { useAppSelector } from '@/state/hooks';
import { selectCurrencyConfigs } from '@/state/reducers/ohoSlice';
import { useCallback, useMemo } from 'react';

interface CurrencyOption {
    label: string;
    ccy: string;
    value: string;
    celer: string;
}

export interface UseCurrencyConfigOptionsReturn {
    currencyOptions: CurrencyOption[];
    defaultFrom: CurrencyOption | null;
    defaultTo: CurrencyOption | null;
}

export const useCurrencyConfigOptions = (): UseCurrencyConfigOptionsReturn => {
    const currencyConfigs = useAppSelector(selectCurrencyConfigs);

    const currencyOptions = currencyConfigs.map((ccy) => {
        return {
            label: ccy.longName,
            ccy: ccy.show.toLowerCase(),
            value: ccy.show,
            celer: ccy.celer
        };
    });

    const ccyOption = useCallback(
        (name: string) => {
            const ccy = currencyOptions.find((ccy) => ccy.ccy === name);
            return ccy ? ccy : null;
        },
        [currencyOptions]
    );

    const defaultFrom = useMemo(() => {
        return ccyOption('usd') || ccyOption('usdt') || currencyOptions[0];
    }, [ccyOption, currencyOptions]);

    const defaultTo = useMemo(() => {
        return ccyOption('btc') || ccyOption('eth') || ccyOption('eur') || currencyOptions[1];
    }, [ccyOption, currencyOptions]);

    // const alternativeFrom = useMemo(() => {
    //     return ccyOption('btc') || ccyOption('eth') || ccyOption('eur') || currencyOptions[0];
    // }, [ccyOption, currencyOptions]);

    // const alternativeTo = useMemo(() => {
    //     return ccyOption('usd') || ccyOption('usdt') || ccyOption('eur') || currencyOptions[1];
    // }, [ccyOption, currencyOptions]);

    return {
        currencyOptions,
        defaultFrom,
        defaultTo
    };
};
